var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('app-headline',{attrs:{"title":_vm.title}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('leave-cancel-filter')],1),_c('v-col',[_c('leave-cancel-table')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }